'use strict';

import controller from './evaluacion.controller';
import template from './evaluacion.html';

const DatosEvaluacion = {
  bindings:{
    proyecto: '=',
    modoVista: '<'
  },
  controller,
  template
};

export default DatosEvaluacion;



// WEBPACK FOOTER //
// ./src/app/components/reg-proyectos/c-proyectos/evaluacion/evaluacion.component.js